module.exports = __webpack_public_path__ + "static/media/remember_07.240f3ab6.png";